import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "audio_play",
  "use": "audio_play-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol viewBox=\"0 0 96 96\" id=\"audio_play\">\n    <path fill=\"#F5A623\" d=\"M 95,50 5,95 5,5 z\" />\n  </symbol>"
});
var result = sprite.add(symbol);
export default symbol